import { Dialog, SizableText, XStack, YStack } from '@my/ui'
import { UserAvatar } from 'app/features/user/components'
import { User } from 'app/types'

interface UserPopupProps {
  user: Pick<
    User,
    'id' | 'fullName' | 'university' | 'subjectOfStudy' | 'avatar'
  > | null
  children?: React.ReactNode
  onOpenChange: (value: boolean) => void
  open: boolean
}

export const UserPopup = (props: UserPopupProps) => {
  const { user } = props

  if (!user) return null

  return (
    <Dialog key={`UserModal:${user.id}`} modal open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Portal zIndex="$2" p="$3.5">
        <Dialog.Overlay
          onPress={() => props.onOpenChange(false)}
          key="overlay"
          bg="$overlay13"
          animation="quick"
          opacity={0.5}
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />

        <Dialog.Content
          width="100%"
          maxWidth={360}
          borderRadius="$3"
          key="content"
          p="$4"
          shadowOpacity={0}
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          y={0}
          opacity={1}
          enterStyle={{ opacity: 0, y: 100 }}
          exitStyle={{ opacity: 0, y: 100 }}
        >
          <XStack gap="$3.5" alignItems="flex-start">
            <UserAvatar flexShrink={0} width={100} height={100} src={user?.avatar?.medium} />
            <YStack flex={1} gap="$1">
              <SizableText numberOfLines={3} size="$8" fow="500">
                {user.fullName}
              </SizableText>

              {user.subjectOfStudy && (
                <SizableText size="$3" fow="500">
                  {user.subjectOfStudy.name}
                </SizableText>
              )}

              {user.university?.name && (
                <SizableText pt="$1" color="$overlay10" size="$1" fow="500">
                  {user.university.name}
                </SizableText>
              )}
            </YStack>
          </XStack>

          {props.children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
